module.exports = __webpack_public_path__ + "static/media/ParcelDelivery.568d3595.png";